import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useTmpAuthAtom from "shared/model/useConfrimCookie"

const useGetAuthId = () => {

    const [fetchResult, fetchRequest] = useFetch()
    const [, , deleteTmpToken] = useTmpAuthAtom()
    const [, setAlert] = useAlertModalAtom()

    const getAccountIdEvent = () => {
        fetchRequest("GET", "/auth/id")
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 404:
                if (fetchResult?.data?.error_code === 1) {
                    setAlert("가입된 계정이 아니거나\n다른 방법으로 가입된 계정입니다.")
                    deleteTmpToken()
                }
                break

        }
    }, [fetchResult])

    return [fetchResult, getAccountIdEvent]
}

export default useGetAuthId